(function(){
  var root = document.querySelector('[data-aweri-coll]'); if (!root) { return; }
  if(!root) return;
  var SECTION_ID = root.dataset.sectionId;
  var fams = [].slice.call(root.querySelectorAll('.aweri-coll__fam'));
  var anchors = [].slice.call(root.querySelectorAll('[data-anchor]'));
  var cards = [].slice.call(root.querySelectorAll('.aweri-coll__grid .aweri-card'));
  var countEl = root.querySelector('[data-aweri-count]');
  var sheetCountEl = root.querySelector('[data-aweri-sheet-count]');
  var emptyEl = root.querySelector('[data-aweri-empty]');
  var noun = root.dataset.noun || 'items';
  var panel = root.querySelector('[data-aweri-facets]');
  var overlay = root.querySelector('.aweri-coll__sheet-overlay');
  var filterBtn = root.querySelector('.aweri-coll__pill--filter');
  var badgeEl = root.querySelector('[data-aweri-badge]');
  var appliedEl = root.querySelector('[data-aweri-applied]');
  var applyBtn = root.querySelector('[data-aweri-apply]');
  var controls = root.querySelector('.aweri-coll__controls');
  // The 16-tag taxonomy axes (wiki DECISIONS 2026-06-11 SURFACES). A page renders only the axes in its
  // matrix; the others stay empty here (harmless). Every chip's data-f is a real product tag.
  var GROUPS = ['category','type','format','goodfor','craving'];

  // Capture the clean chip label BEFORE we append count spans; add a count span to each chip.
  var labels = {};
  function indexChips(){
    if(!panel) return;
    panel.querySelectorAll('.aweri-coll__chip').forEach(function(ch){
      var key = ch.getAttribute('data-g') + '/' + ch.getAttribute('data-f');
      if(!(key in labels)) labels[key] = ch.textContent.trim();
      if(!ch.querySelector('.aweri-coll__chip-n')){
        var s = document.createElement('span');
        s.className = 'aweri-coll__chip-n';
        ch.appendChild(s);
      }
    });
  }
  indexChips();

  var sel = { category:{}, type:{}, format:{}, goodfor:{}, craving:{} };
  function anySel(g){ for(var k in sel[g]) return true; return false; }
  function activeCount(){ var n=0; GROUPS.forEach(function(g){ for(var k in sel[g]) n++; }); return n; }

  // A card's facet membership IS its tag set (data-tags); every chip's data-f is a real tag.
  function cardTags(c){ return (c.getAttribute('data-tags') || '').split(','); }
  // Does a card pass the current selection? (OR within a group, AND across groups.)
  // skipGroup lets us compute contextual per-option counts (ignore the option's own group).
  function cardMatches(c, skipGroup){
    var ok = true;
    var tags = cardTags(c);
    GROUPS.forEach(function(g){
      if(!ok || g === skipGroup || !anySel(g)) return;
      var hit = false;
      for(var k in sel[g]){ if(tags.indexOf(k) > -1){ hit = true; break; } }
      if(!hit) ok = false;
    });
    return ok;
  }

  // ----- open / close. The Filter pill + the floating FAB both open the bottom sheet (item 8b).
  //        Items 21+28: overlay tap-close / scroll lock / focus trap / ESC / focus return / bfcache reset
  //        all come from the shared AweriModal contract (assets/aweri-modal.js) - not re-implemented here. -----
  function isOpen(){ return panel && panel.classList.contains('open'); }
  function setOpen(open, sheet){
    if(panel){
      if(open) panel.classList.toggle('is-sheet', !!sheet);
      panel.classList.toggle('open', open);
    }
    var sheetMode = panel && panel.classList.contains('is-sheet');
    if(filterBtn) filterBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    // A11Y-03: expose role=dialog / aria-modal ONLY while the sheet is open (closed state is hidden by max-height:0,
    // not display:none, so a static role would leak to assistive tech). Same open && sheetMode guard as AweriModal.open below.
    if(panel){ if(open && sheetMode){ panel.setAttribute('role','dialog'); panel.setAttribute('aria-modal','true'); } else { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); } }
    if(window.AweriModal){
      if(open && sheetMode){
        AweriModal.open('coll-filter', { panel: panel, overlay: overlay, initialFocus: panel.querySelector('.aweri-coll__sheet-x'), onClose: function(){ setOpen(false); flushPendingScroll(); } });
      } else {
        AweriModal.close('coll-filter');
      }
    }
  }
  root.querySelectorAll('[data-aweri-filter-toggle]').forEach(function(el){
    el.addEventListener('click', function(){
      // Item 8b: the Filter pill ALWAYS opens the bottom sheet (one pattern with the scroll FAB, every width);
      // the X / overlay / "Show results" just close it.
      if(el === filterBtn) setOpen(!isOpen(), true);
      else setOpen(false);
    });
  });

  // ----- render -----
  function apply(){
    var n = 0;
    cards.forEach(function(c){
      var ok = cardMatches(c, null);
      c.style.display = ok ? '' : 'none';
      if(ok) n++;
    });
    // Hide a family section + its anchor chip when it has zero visible cards (dynamic zero-count law).
    fams.forEach(function(fam){
      var vis = [].slice.call(fam.querySelectorAll('.aweri-card')).some(function(c){ return c.style.display !== 'none'; });
      fam.hidden = !vis;
      var key = fam.getAttribute('data-fam');
      anchors.forEach(function(a){ if(a.getAttribute('data-anchor') === key) a.hidden = !vis; });
    });
    if(countEl) countEl.textContent = n + ' ' + noun;
    if(sheetCountEl) sheetCountEl.textContent = n + ' ' + noun;
    if(emptyEl) emptyEl.hidden = n !== 0;
    if(applyBtn) applyBtn.textContent = 'Show ' + n + ' ' + noun;
    requestAnimationFrame(updateChipFades);   // hiding chips changes the scroller width -> refresh the edge fades
    return n;
  }

  function renderCounts(){
    if(!panel) return;
    panel.querySelectorAll('.aweri-coll__chip').forEach(function(ch){
      var g = ch.getAttribute('data-g'), f = ch.getAttribute('data-f'), cnt = 0;
      cards.forEach(function(c){
        if(cardTags(c).indexOf(f) < 0) return;
        if(cardMatches(c, g)) cnt++;
      });
      var nEl = ch.querySelector('.aweri-coll__chip-n');
      if(nEl) nEl.textContent = '(' + cnt + ')';
      ch.classList.toggle('is-zero', cnt === 0 && !sel[g][f]);
    });
    // Group disappears when every value in it has zero-count (so no orphan "Craving" header with no chips).
    panel.querySelectorAll('.aweri-coll__fgroup').forEach(function(grp){
      var live = 0;
      grp.querySelectorAll('.aweri-coll__chip').forEach(function(ch){ if(!ch.classList.contains('is-zero')) live++; });
      grp.hidden = live === 0;
    });
  }

  function renderApplied(){
    if(!appliedEl) return;
    appliedEl.innerHTML = '';
    if(activeCount() === 0){ appliedEl.hidden = true; return; }
    appliedEl.hidden = false;
    var lab = document.createElement('span');
    lab.className = 'aweri-coll__applied-label';
    lab.textContent = 'Filtered by:';
    appliedEl.appendChild(lab);
    GROUPS.forEach(function(g){
      Object.keys(sel[g]).forEach(function(f){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aweri-coll__applied-chip';
        b.setAttribute('aria-label', 'Remove ' + (labels[g+'/'+f] || f) + ' filter');
        b.appendChild(document.createTextNode((labels[g+'/'+f] || f) + ' '));
        var x = document.createElement('span'); x.setAttribute('aria-hidden','true'); x.textContent = '×';
        b.appendChild(x);
        b.addEventListener('click', function(){ toggle(g, f, false); });
        appliedEl.appendChild(b);
      });
    });
    var clr = document.createElement('button');
    clr.type = 'button';
    clr.className = 'aweri-coll__applied-clear';
    clr.textContent = 'Clear all';
    clr.addEventListener('click', clearAll);
    appliedEl.appendChild(clr);
  }

  function renderBadges(){
    var ac = activeCount();
    if(badgeEl){ badgeEl.textContent = ac; badgeEl.hidden = ac === 0; }
    if(filterBtn) filterBtn.classList.toggle('has-active', ac > 0);
  }

  function syncChipStates(){
    if(!panel) return;
    panel.querySelectorAll('.aweri-coll__chip').forEach(function(ch){
      var on = !!sel[ch.getAttribute('data-g')][ch.getAttribute('data-f')];
      ch.classList.toggle('on', on);
      ch.setAttribute('aria-pressed', on ? 'true' : 'false');   // C7f: toggle-button state for SR users
    });
  }

  // URL keys are prefixed: bare names like "format" collide with reserved Shopify params (e.g. ?format=* 404s).
  var PFX = 'aw_';
  function writeURL(){
    try{
      var params = new URLSearchParams(window.location.search);
      GROUPS.forEach(function(g){
        var keys = Object.keys(sel[g]);
        if(keys.length) params.set(PFX + g, keys.join(',')); else params.delete(PFX + g);
      });
      var qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    }catch(e){}
  }

  function render(){ apply(); renderCounts(); renderApplied(); renderBadges(); syncChipStates(); writeURL(); }

  function toggle(g, f, on){
    if(on === undefined) on = !sel[g][f];
    if(on) sel[g][f] = 1; else delete sel[g][f];
    render();
    repositionAfterFilter();
  }
  function clearAll(){ sel = { category:{}, type:{}, format:{}, goodfor:{}, craving:{} }; render(); repositionAfterFilter(); }

  // ----- keep the viewport on the results after a filter apply/clear (no footer-stranding) -----
  // A filter shortens the page; the shared modal's unlockScroll (aweri-modal.js) restores the PRE-open
  // scroll position when the sheet closes, which can leave the viewport below the now-shorter results
  // (stranded on the footer). After any user filter change, snap to the first still-visible family header -
  // its scroll-margin-top (= --aweri-header-h + space) clears the sticky header. Init + the overflow
  // page-stitch call render() directly (never toggle/clearAll), so they never fire this; only gestures do.
  var pendingScroll = false;
  function scrollToResults(){
    var target = null;
    for(var i = 0; i < fams.length; i++){ if(!fams[i].hidden){ target = fams[i]; break; } }
    if(!target) target = (emptyEl && !emptyEl.hidden) ? emptyEl : controls;
    if(!target || !target.scrollIntoView) return;
    // Instant snap, NOT smooth: a filter can shrink OR grow the page by thousands of px, and a smooth crawl
    // across that is slow + janky (and races the page-grow reflow on clear-all). block:'start' + the
    // .aweri-coll__fam scroll-margin-top land the header just under the sticky bar. (Instant = reduced-motion-safe.)
    target.scrollIntoView({ block: 'start' });
  }
  function repositionAfterFilter(){
    // Sheet open: defer the snap to when it closes (unlockScroll would otherwise override it). Sheet
    // closed (applied-chip remove / clear-all / empty-state clear): snap on the next frame.
    if(isOpen()) pendingScroll = true;
    else requestAnimationFrame(scrollToResults);
  }
  function flushPendingScroll(){
    if(!pendingScroll) return;
    pendingScroll = false;
    requestAnimationFrame(scrollToResults);
  }

  if(panel) panel.querySelectorAll('.aweri-coll__chip').forEach(function(ch){
    ch.addEventListener('click', function(){ toggle(ch.getAttribute('data-g'), ch.getAttribute('data-f')); });
  });
  root.querySelectorAll('[data-aweri-clear]').forEach(function(el){
    el.addEventListener('click', clearAll);
  });

  // ----- sort (slice 4): navigate to ?sort_by=, PRESERVING the client filter params (aw_*) so filters
  //        compose with both modes. Recommended = no param (structured scroll); a real sort value = flat grid. -----
  var sortSel = root.querySelector('[data-aweri-sort]');
  if(sortSel){
    sortSel.addEventListener('change', function(){
      this.blur();                                   // drop focus so no ring/native-picker state lingers after the pick
      var params = new URLSearchParams(window.location.search);
      if(this.value) params.set('sort_by', this.value); else params.delete('sort_by');
      params.delete('page');
      var qs = params.toString();
      window.location = window.location.pathname + (qs ? '?' + qs : '');
    });
  }

  // ----- restore state from the URL -----
  function readURL(){
    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function(g){
      var v = params.get(PFX + g);
      if(v) v.split(',').forEach(function(f){ if(f) sel[g][f] = 1; });
    });
  }


  // ----- overflow safety net: if a collection exceeds 50 raw products, stitch later pages per-family.
  //        Each fetched page is already family-grouped server-side, so we merge same-key grids (no JS classifier).
  //        Recommendation: keep browse collections <=50 so this never runs (flagged in the plan). -----
  function loadAllPages(){
    var wrap = root.querySelector('[data-aweri-fams]');
    var pages = wrap ? (parseInt(wrap.getAttribute('data-pages'), 10) || 1) : 1;
    if(pages < 2) return;
    var reqs = [];
    for(var p = 2; p <= pages; p++){
      reqs.push(
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(SECTION_ID) + '&page=' + p)
          .then(function(r){ return r.ok ? r.text() : ''; })
          .then(function(html){
            if(!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('.aweri-coll__fam').forEach(function(srcFam){
              var key = srcFam.getAttribute('data-fam');
              var destGrid = root.querySelector('.aweri-coll__fam[data-fam="' + key + '"] .aweri-coll__grid');
              var srcGrid = srcFam.querySelector('.aweri-coll__grid');
              if(destGrid && srcGrid){
                [].slice.call(srcGrid.querySelectorAll('.aweri-card')).forEach(function(card){ destGrid.appendChild(card); });
              }
            });
          })
          .catch(function(e){ if(window.console){ console.warn('[aweri-coll] overflow page stitch failed; server families stand', e); } })
      );
    }
    Promise.all(reqs).then(function(){
      cards = [].slice.call(root.querySelectorAll('.aweri-coll__grid .aweri-card'));
      var pg = root.querySelector('.aweri-coll__pagination');
      if(pg) pg.style.display = 'none';
      if(window.jdgm && typeof window.jdgm.batchRenderBadges === 'function'){ try{ window.jdgm.batchRenderBadges(); }catch(e){} }
      render();
    });
  }

  // ----- scroll-spy: highlight the active section's chip + bring it into view (M1, owner-locked).
  //        We scroll THE CHIP CONTAINER ONLY (compute the delta from bounding rects + scrollBy) - never
  //        scrollIntoView, which scrolls the PAGE (the known trap). Tapping a chip jumps the page (plain
  //        anchor href); the IO then re-fires and re-syncs the highlight + recentres the chip. Fade masks
  //        (is-clip-start/-end) mark the clipped edges of the scroller. -----
  var anchorsBox = root.querySelector('[data-aweri-anchors]');
  var fadeTick = false;
  var recentreT;                                                          // PC-06: coalesces the scroll-spy's recentre (see the IO callback)
  function updateChipFades(){
    if(!anchorsBox) return;
    var max = anchorsBox.scrollWidth - anchorsBox.clientWidth;
    anchorsBox.classList.toggle('is-clip-start', anchorsBox.scrollLeft > 1);
    anchorsBox.classList.toggle('is-clip-end', anchorsBox.scrollLeft < max - 1);
  }
  function bringChipIntoView(a){
    if(!anchorsBox || !a) return;
    var cb = anchorsBox.getBoundingClientRect();
    var ab = a.getBoundingClientRect();
    var pad = 24;                                                          // var(--aweri-space-5) breathing room
    var delta = 0;
    if(ab.left < cb.left + pad) delta = ab.left - cb.left - pad;           // chip clipped to the left -> reveal
    else if(ab.right > cb.right - pad) delta = ab.right - cb.right + pad;  // clipped to the right -> reveal
    if(Math.abs(delta) < 4) return;                                        // PC-06: already centred (<4px) - skip the no-op smooth scroll
    if(anchorsBox.scrollBy) anchorsBox.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    else anchorsBox.scrollLeft += delta;                                   // (the scroll event keeps the fades in sync)
  }
  if(anchorsBox) anchorsBox.addEventListener('scroll', function(){
    if(fadeTick) return; fadeTick = true;
    requestAnimationFrame(function(){ fadeTick = false; updateChipFades(); });
  }, { passive: true });
  window.addEventListener('resize', updateChipFades, { passive: true });
  updateChipFades();

  if('IntersectionObserver' in window && anchors.length){
    var byKey = {};
    anchors.forEach(function(a){ byKey[a.getAttribute('data-anchor')] = a; });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var a = byKey[e.target.getAttribute('data-fam')];
        if(a){
          anchors.forEach(function(x){ x.classList.remove('is-active'); }); a.classList.add('is-active');  // highlight tracks in real time - never debounced
          // PC-06: on FAST scroll several family sections cross the active band in quick succession, each firing
          // its own smooth scrollBy on the chip row -> the competing animations fight = a horizontal shimmy.
          // Debounce ONLY the recentre (not the highlight): rapid crossings collapse to ONE scroll on the FINAL
          // active chip after scrolling settles. Recompute the active chip in the timer (not the stale closed-over a).
          clearTimeout(recentreT);
          recentreT = setTimeout(function(){
            var active = anchorsBox && anchorsBox.querySelector('.aweri-coll__anchor.is-active');
            if(active) bringChipIntoView(active);
          }, 140);
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
    fams.forEach(function(f){ io.observe(f); });
  }

  // ----- init -----
  readURL();
  render();
  // PERF-07: stitch overflow pages (only >50-product collections; loadAllPages no-ops under that) OFF the
  // critical path - it still loads ALL pages so facet filter/sort/count operate on the full set, just not
  // synchronously at init (the fetch + per-page DOMParse was a load-time INP/TBT cost).
  if ('requestIdleCallback' in window) { requestIdleCallback(loadAllPages, { timeout: 2000 }); }
  else { setTimeout(loadAllPages, 200); }
})();
